import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { store } from './redux';
import GetSiteData from './axios/get_site_data';
import GetDataVersion from './axios/get_data_version';
import Tic from './components/Tic';
import SwitchPageUsingBrowserBTNs from './components/SwitchPageUsingBrowserBTNs';
import CookieConsent from './components/CookieConsent';
// import ReduxDebugger from './components/ReduxDebugger';
import Header from './components/_structure/header';
import Main from './components/_structure/main';
import Footer from './components/_structure/footer';
import styles from './App.module.scss';

function App() {
  return (
    <Provider store={store}>
        <Router>
          <GetSiteData />
          <GetDataVersion />
          <Tic />
          <SwitchPageUsingBrowserBTNs />
          {/* <ReduxDebugger /> */}
          <div className={styles.app}>
            <Header />
            <Main />
            <Footer />
            <CookieConsent />
          </div>
        </Router>
    </Provider>
  );
}

export default App;
